import { useState } from "react";

const Tabs =  ({tabsData, clickHandler }) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  return (
   
    <div className="flex flex-row gap-2 overflow-x-auto md:flex-col">
    
    {tabsData.map((tab, idx) => {
    return (
        <button
        key={idx}
        className={`whitespace-nowrap rounded-lg px-3 py-2 text-left text-xs font-bold transition-colors duration-200 md:text-sm ${
            idx === activeTabIndex
            ? "bg-cyan-50 text-cyan-900"
            : "text-slate-500 hover:bg-slate-100 hover:text-slate-700"
        }`}
        /* condition classname */
        onClick={() => {
          clickHandler(idx)
          setActiveTabIndex(idx)
        }
        }>
        {tab.label}
        </button>
    );
    })}
</div>

  );
}
export default Tabs;
